'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    (0, _jquery2.default)('.add-to-cart-form input').keydown(function (e) {
        if (e.keyCode === 38 || e.keyCode === 40) {
            e.preventDefault();
            var arr = (0, _jquery2.default)('.add-to-cart-form input').map(function () {
                return parseInt((0, _jquery2.default)(this).attr('tabindex'));
            }).get();

            var index = parseInt((0, _jquery2.default)(this).attr('tabindex'));
            var modifiedIndex = 0;

            if (e.keyCode === 38) {
                modifiedIndex = index - 1;
            } else if (e.keyCode === 40) {
                modifiedIndex = index + 1;
            }

            if (arr.indexOf(modifiedIndex) > -1 && modifiedIndex !== 0) {
                (0, _jquery2.default)('.add-to-cart-form input[tabindex=' + modifiedIndex + ']').focus();
            }
        }
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/catalogueAddToCart.js
// module id = 932
// module chunks = 0